import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconIotProps } from './IconIot.types'
import * as Styled from './styles/IconIot.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIot: FC<IconIotProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIotProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconIotProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M12 14.516v3.453m3.387-11.653c-.762-1.918-2.688-3.332-4.739-3.332-2.375 0-4.234 1.907-4.59 4.278h.008C4.551 7.715 3.5 9.199 3.5 10.875c0 2.012 1.738 3.645 3.75 3.645h9.082a4.081 4.081 0 0 0 4.082-4.075c0-2.25-1.383-4.195-4.316-4.195-.239 0-.477.023-.711.07Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M14.5 14.516v2.523a1 1 0 0 0 1 .992h1.074m-9.14 0h1.074a1 1 0 0 0 1-.992v-2.523m-2.074 3.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 0Zm6.07 1.5a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 0Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M19.57 18.016a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 0Zm0 0' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconIot
